import { render, staticRenderFns } from "./SendPlannerIntroduce.vue?vue&type=template&id=554c57fb&"
import script from "./SendPlannerIntroduce.vue?vue&type=script&lang=js&"
export * from "./SendPlannerIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports